import { render, staticRenderFns } from "./playVideo.vue?vue&type=template&id=0b3036b0&scoped=true&"
import script from "./playVideo.vue?vue&type=script&lang=js&"
export * from "./playVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3036b0",
  null
  
)

export default component.exports